import PageType from './PageType.jsx';

const Name = {
    Block: {
        Accordion: 'Accordion',
        Artist: {
            Bio: {
                Group: 'ArtistBioGroup',
                Legacy: 'Artist_Bio',
                Tabbed: 'TabbedArtistBioGroup',
                Text: 'Artist_Bio_Tokenized'
            },
            Blog: {
                List: 'Artist_Blogs'
            },
            Cell: {
                Image: 'Artist_Cell_Image',
                ImageHover: 'ArtistCellImageHover',
                Text: 'Artist_Cell_Meta'
            },
            CV: 'ArtistCV',
            ImageParallax: 'Artist_ImageParallax',
            ImageV1: 'Artist_Image',                        // DEPRECATED - use `Name.Block.Artist.ImageV2`
            ImageV2: 'Artist_Image_v2',
            Inventory: {
                ListV1: 'Artist_Inventory',                 // DEPRECATED - use `Name.Block.Artist.Inventory.ListV4`
                ListV2: 'Artist_Inventory_v2',              // DEPRECATED - use `Name.Block.Artist.Inventory.ListV4`
                ListV3: 'Artist_Inventory_v3',              // DEPRECATED - use `Name.Block.Artist.Inventory.ListV4`
                ListV4: 'Artist_Inventory_v4'
            },
            List: 'ArtistsList',                            // DEPRECATED - use `Name.Block.Artist.ListV2`
            ListV2: 'ArtistsList_v2',
            Media: {
                List: 'Artist_Media'
            },
            NameV1: 'Artist_Name',
            NameV2: 'Artist_Name_v2',                       // DEPRECATED - use `Name.Block.Artist.NameV1`
            Show: {
                List: {
                    Grid: 'Artist_Shows',
                    Parallax: 'Artist_ShowsParallax',
                    Slideshow: 'Artist_ShowsSlideshow',
                    SlideshowFullBackground: 'Artist_ShowsSlideshow-FullBackground'
                }
            },
            SignupV1: 'ArtistSignup',                       // DEPRECATED - use `Name.Block.Artist.Signup.Container`
            Signup: {
                Container: 'ArtistSignup_v2',
                ErrorMessage: 'ArtistSignup_ErrorMessage',
                Input: {
                    Email: 'ArtistSignup_Email',
                    Name: 'ArtistSignup_Name'
                },
                SuccessMessage: 'ArtistSignup_SuccessMessage',
                SubmitButtonV1: 'ArtistSignup_SubmitButton',    // DEPRECATED - use `Name.Block.Artist.Signup.SubmitButtonV2`
                SubmitButtonV2: 'ArtistSignup_SubmitButton_v2'
            },
            TabsV1: 'Artist_Tabs',                          // DEPRECATED - use `Name.Block.Artist.TabsV3`
            TabsV2: 'Artist_Tabs_v2',                       // DEPRECATED - use `Name.Block.Artist.TabsV3`
            TabsV3: 'Artist_Tabs_v3',
        },
        Blog: {
            Cell: {
                Image: 'Blog_Cell_Image',
                Text: 'Blog_Cell_Meta'
            },
            ImageParallax: 'Blog_ImageParallax',
            List: 'Blogs',
            Meta: 'PostContentMeta',
            TitleV1: 'PostContentTitle',                    // DEPRECATED - use `Name.Block.Blog.TitleV2`
            TitleV2: 'PostContentTitle_v2'
        },
        ButtonV1: 'Button',                                 // DEPRECATED - use `Name.Block.ButtonV3`
        ButtonV2: 'Button_v2',                              // DEPRECATED - use `Name.Block.ButtonV3`
        ButtonV3: 'Button_v3',
        Cart: {
            ApplePayButton: 'Cart_ApplePayButton',
            CardFormV1: 'Cart_CardForm',                    // DEPRECATED - use `Name.Block.Cart.CardForm.Container`
            CardForm: {
                Container: 'Cart_CardForm_v2',
                ErrorMessage: 'Cart_CardForm_ErrorMessage',
                Input: {
                    BillingAddress: {
                        AddressLine1: 'Cart_CardForm_AddressLine1',
                        AddressLine2: 'Cart_CardForm_AddressLine2',
                        City: 'Cart_CardForm_City',
                        Country: 'Cart_CardForm_Country',
                        State: 'Cart_CardForm_State',
                        Zip: 'Cart_CardForm_Zip'
                    },
                    CardNumber: 'Cart_CardForm_CardNumber',
                    Email: 'Cart_CardForm_Email',
                    ExpirationDate: 'Cart_CardForm_ExpirationDate',
                    FirstName: 'Cart_CardForm_FirstName',
                    LastName: 'Cart_CardForm_LastName',
                    Notes: 'Cart_CardForm_Notes',
                    Phone: 'Cart_CardForm_Phone',
                    SecurityCode: 'Cart_CardForm_SecurityCode',
                    ShippingAddress: {
                        AddressLine1: 'Cart_CardForm_ShippingAddressLine1',
                        AddressLine2: 'Cart_CardForm_ShippingAddressLine2',
                        City: 'Cart_CardForm_ShippingCity',
                        Country: 'Cart_CardForm_ShippingCountry',
                        State: 'Cart_CardForm_ShippingState',
                        Zip: 'Cart_CardForm_ShippingZip'
                    }
                },
                SameAddressCheckbox: 'Cart_CardForm_SameAddressCheckbox'
            },
            LineItem: {
                Cell: {
                    InventoryLineItemQuantityInput: 'Cart_InventoryLineItemQuantityInput',
                    PromoCodeLineItemText: 'Cart_PromoCodeLineItemText'
                },
                List: 'Cart_LineItems'
            },
            PromoCodeV1: 'Cart_PromoCode',                  // DEPRECATED - use `Name.Block.Cart.PromoCode.Container`
            PromoCode: {
                Container: 'Cart_PromoCode_v2',
                ErrorMessage: 'Cart_PromoCode_ErrorMessage',
                Input: {
                    Code: 'Cart_PromoCode_Code'
                },
                SubmitButtonV1: 'Cart_PromoCode_SubmitButton',  // DEPRECATED - use `Name.Block.Cart.PromoCode.SubmitButtonV2`
                SubmitButtonV2: 'Cart_PromoCode_SubmitButton_v2'
            },
            PurchaseButtonV1: 'Cart_PurchaseButton',        // DEPRECATED - use `Name.Block.Cart.PurchaseButtonV2`
            PurchaseButtonV2: 'Cart_PurchaseButton_v2',
            RemoveButton: 'Cart_RemoveButton',
            Shipping: 'Cart_Shipping',
            StripeElements: 'Cart_StripeElements',
            Subtotal: 'Cart_Subtotal',
            Tax: 'Cart_Tax'
        },
        CloseButton: 'CloseButton',
        Code: 'code',
        Columns: 'columns',
        Contact: {
            Address: 'Address',
            FormV1: 'ContactForm',                          // DEPRECATED - use `Name.Block.Contact.Form.Container`
            Form: {
                Container: 'ContactForm_v2',
                ErrorMessage: 'ContactForm_ErrorMessage',
                Input: {
                    Address: {
                        City: 'ContactForm_AddressCity',
                        Country: 'ContactForm_AddressCountry',
                        Line1: 'ContactForm_AddressLine1',
                        Line2: 'ContactForm_AddressLine2',
                        State: 'ContactForm_AddressState',
                        Zip: 'ContactForm_AddressZip'
                    },
                    Email: 'ContactForm_Email',
                    Message: 'ContactForm_Message',
                    Name: 'ContactForm_Name',
                    Phone: 'ContactForm_Phone',
                    Subject: 'ContactForm_Subject'
                },
                SuccessMessage: 'ContactForm_SuccessMessage',
                SubmitButtonV1: 'ContactForm_SubmitButton', // DEPRECATED - use `Name.Block.Contact.Form.SubmitButtonV2`
                SubmitButtonV2: 'ContactForm_SubmitButton_v2'
            },
            HoursV1: 'Hours',                               // DEPRECATED - use `Name.Block.Contact.HoursV2`
            HoursV2: 'Hours_v2'
        },
        CookiePolicy: {
            Button: {
                Accept: 'cookiePolicy_AcceptButton',
                Reject: 'cookiePolicy_RejectButton'
            },
            Container: 'cookiePolicy'
        },
        Custom: 'Custom',
        Footer: {
            Address: 'footer_address',                      // DEPRECATED - use `Name.Block.Contact.Address`
            LogoV1: 'footer_logo',                          // DEPRECATED - use `Name.Block.Footer.LogoV2`
            LogoV2: 'footer_logo_v2',
            QuickLinksV1: 'footer_quickLinks',              // DEPRECATED - use `Name.Block.Footer.QuickLinksV2`
            QuickLinksV2: 'footer_quickLinks_v2',
            Social: 'footer_social',                        // DEPRECATED - use `Name.Block.SocialV2`
            SubscribeFormV1: 'footer_subscribe',            // DEPRECATED - use `Name.Block.Footer.SubscribeForm.Container`
            SubscribeForm: {
                Container: 'footer_subscribe_v2',
                ErrorMessage: 'footer_subscribe_ErrorMessage',
                Input: {
                    Address: {
                        City: 'footer_subscribe_AddressCity',
                        Country: 'footer_subscribe_AddressCountry',
                        Line1: 'footer_subscribe_AddressLine1',
                        Line2: 'footer_subscribe_AddressLine2',
                        State: 'footer_subscribe_AddressState',
                        Zip: 'footer_subscribe_AddressZip'
                    },
                    Email: 'footer_subscribe_Email',
                    Name: 'footer_subscribe_Name',
                    Phone: 'footer_subscribe_Phone'
                },
                SuccessMessage: 'footer_subscribe_SuccessMessage',
                SubmitButtonV1: 'footer_subscribe_SubmitButton',    // DEPRECATED - use `Name.Block.Footer.SubscribeForm.SubmitButtonV2`
                SubmitButtonV2: 'footer_subscribe_SubmitButton_v2'
            }
        },
        Representative: {
            Cell: {
                Text: 'Gallery_Cell_Meta'
            },
            List: 'Galleries'
        },
        Group: {
            FloatingColumnsBottom: 'FloatingColumnsBottom',
            FloatingColumnsTop: 'FloatingColumnsTop'
        },
        Header: {
            CartLink: 'header_cart',
            LogoV1: 'header_logo',                          // DEPRECATED - use `Name.Block.Header.LogoV2`
            LogoV2: 'header_logo_v2',
            MenuItemsV1: 'header_menu',                     // DEPRECATED - use `Name.Block.Header.MenuItemsV2`
            MenuItemsV2: 'header_menu_v2',
            MobileToggle: 'header_mobile_toggle',
            SearchBar: {
                Container: 'header_searchBar',
                Input: {
                    Search: 'header_searchBar_Search'
                },
                SubmitButtonV1: 'header_searchBar_SubmitButton',    // DEPRECATED - use `Name.Block.Header.SearchBar.SubmitButtonV2`
                SubmitButtonV2: 'header_searchBar_SubmitButton_v2'
            },
            SearchToggleV1: 'header_search',                // DEPRECATED - use `Name.Block.Header.SearchToggleV2`
            SearchToggleV2: 'header_search_v2'
        },
        HeaderText: 'HeaderText',
        HeaderTextV2: 'HeaderText_v2',                      // DEPRECATED - use `Name.Block.HeaderText`
        HorizontalRule: 'HorizontalRule',
        HoverContent: 'HoverContent',
        ImageV1: 'Image',                                   // DEPRECATED - use `Name.Block.ImageV2`
        ImageV2: 'Image_v2',
        ImageGallery: 'ImageGallery',
        InquireForm: {
            CancelButton: 'InquireForm_CancelButton',
            Container: 'InquireForm',
            ErrorMessage: 'InquireForm_ErrorMessage',
            Input: {
                Address: {
                    City: 'InquireForm_AddressCity',
                    Country: 'InquireForm_AddressCountry',
                    Line1: 'InquireForm_AddressLine1',
                    Line2: 'InquireForm_AddressLine2',
                    State: 'InquireForm_AddressState',
                    Zip: 'InquireForm_AddressZip'
                },
                Email: 'InquireForm_Email',
                Message: 'InquireForm_Message',
                Name: 'InquireForm_Name',
                Phone: 'InquireForm_Phone'
            },
            SuccessMessage: 'InquireForm_SuccessMessage',
            SubmitButtonV1: 'InquireForm_SubmitButton',     // DEPRECATED - use `Name.Block.InquireForm.SubmitButtonV2`
            SubmitButtonV2: 'InquireForm_SubmitButton_v2'
        },
        InstallationPhotos: 'InstallationPhotos',
        Inventory: {
            Artist: {
                Bio: {
                    Group: 'InventoryArtistBioGroup',
                    Legacy: 'Inventory_Artist_Bio',
                    Text: 'Inventory_Artist_Bio_Tokenized'
                },
                CV: 'Inventory_ArtistCV',
                ImageV1: 'Inventory_Artist_Image',          // DEPRECATED - use `Name.Block.Inventory.Artist.ImageV2`
                ImageV2: 'Inventory_Artist_Image_v2',
                NameV1: 'Inventory_Artist_Name',
                NameV2: 'Inventory_Artist_Name_v2'          // DEPRECATED - use `Name.Block.Inventory.Artist.NameV1`
            },
            Blog: {
                List: 'Inventory_Blogs'
            },
            Button: {
                ArtistProfileV1: 'Inventory_Artist_ProfileButton',  // DEPRECATED - use `Name.Block.Inventory.Button.ArtistProfileV2`
                ArtistProfileV2: 'Inventory_Artist_ProfileButton_v2',
                InquireV1: 'Inventory_CTA_Inquire',         // DEPRECATED - use `Name.Block.Inventory.Button.InquireV3`
                InquireV2: 'Inventory_CTA_Inquire_v2',      // DEPRECATED - use `Name.Block.Inventory.Button.InquireV3`
                InquireV3: 'Inventory_CTA_Inquire_v3',
                OfferV1: 'Inventory_CTA_Offer',             // DEPRECATED - use `Name.Block.Inventory.Button.OfferV3`
                OfferV2: 'Inventory_CTA_Offer_v2',          // DEPRECATED - use `Name.Block.Inventory.Button.OfferV3`
                OfferV3: 'Inventory_CTA_Offer_v3',
                PurchaseV1: 'Inventory_CTA_Purchase',       // DEPRECATED - use `Name.Block.Inventory.Button.PurchaseV3`
                PurchaseV2: 'Inventory_CTA_Purchase_v2',    // DEPRECATED - use `Name.Block.Inventory.Button.PurchaseV3`
                PurchaseV3: 'Inventory_CTA_Purchase_v3'
            },
            Cell: {
                Image: 'Inventory_Cell_Image',
                SlideshowImage: 'Inventory_Cell_SlideshowImage',
                Text: 'Inventory_Cell_Meta'
            },
            ControlsV1: 'Inventory_Controls',               // DEPRECATED - use `Name.Block.Inventory.ControlsV2`
            ControlsV2: 'Inventory_Controls_v2',
            EditionSets: 'EditionSets',
            Image: 'Inventory_Image',
            ImageParallax: 'Inventory_ImageParallax',
            ListV1: 'Inventory',                            // DEPRECATED - use `Name.Block.Inventory.ListV4`
            ListV2: 'Inventory_v2',                         // DEPRECATED - use `Name.Block.Inventory.ListV4`
            ListV3: 'Inventory_v3',                         // DEPRECATED - use `Name.Block.Inventory.ListV4`
            ListV4: 'Inventory_v4',
            Media: {
                List: 'Inventory_Media'
            },
            Meta: {
                Group: 'InventoryMetaGroup',
                Legacy: 'Inventory_Meta'
            },
            Presentation: {
                List: 'Inventory_Presentation'
            },
            RecentlyViewed: {
                Cell: {
                    Image: 'Inventory_RecentlyViewed_Cell_Image',
                    Text: 'Inventory_RecentlyViewed_Cell_Meta'
                },
                List: 'Inventory_RecentlyViewed'
            },
            RelatedV1: 'Inventory_Related',                 // DEPRECATED - use `Name.Block.Inventory.RelatedV4`
            RelatedV2: 'Inventory_Related_v2',              // DEPRECATED - use `Name.Block.Inventory.RelatedV4`
            RelatedV3: 'Inventory_Related_v3',              // DEPRECATED - use `Name.Block.Inventory.RelatedV4`
            RelatedV4: 'Inventory_Related_v4',
            Text: 'Inventory_Meta_Tokenized'
        },
        Map: 'Map',
        Media: {
            List: 'Media'
        },
        ModalButtonNext: 'ModalButtonNext',
        ModalButtonPrevious: 'ModalButtonPrevious',
        OfferForm: {
            Container: 'OfferForm',
            ErrorMessage: 'OfferForm_ErrorMessage',
            Input: {
                Email: 'OfferForm_Email',
                Name: 'OfferForm_Name',
                Phone: 'OfferForm_Phone',
                PriceFixed: 'OfferForm_Price_Fixed',
                PricePercent: 'OfferForm_Price_Percent'
            },
            SuccessMessage: 'OfferForm_SuccessMessage',
            SubmitButtonV1: 'OfferForm_SubmitButton',
            SubmitButtonV2: 'OfferForm_SubmitButton_v2'     // DEPRECATED - use `Name.Block.OfferForm.SubmitButtonV2`
        },
        PageTitleV1: 'PageTitle',
        PageTitleV2: 'PageTitle_v2',                        // DEPRECATED - use `Name.Block.PageTitleV1`
        Parallax: 'Parallax',
        PasswordForm: {
            Container: 'PasswordForm',
            ErrorMessage: 'PasswordForm_ErrorMessage',
            Input: {
                Password: 'PasswordForm_Password'
            },
            SubmitButton: 'PasswordForm_SubmitButton',
        },
        PurchasePopup: {
            CartButtonV1: 'PurchasePopup_CartButton',       // DEPRECATED - use `Name.Block.PurchasePopup.CartButtonV2`
            CartButtonV2: 'PurchasePopup_CartButton_v2',
            Container: 'PurchasePopup_Container',
            ContinueButtonV1: 'PurchasePopup_ContinueButton', // DEPRECATED - use `Name.Block.PurchasePopup.ContinueButtonV2`
            ContinueButtonV2: 'PurchasePopup_ContinueButton_v2',
            DropDown: {
                DimensionsV1: 'PurchasePopup_PurchaseDropDown', // DEPRECATED - use `Name.Block.PurchasePopup.DropDown.DimensionsV2`
                DimensionsV2: 'PurchasePopup_PurchaseDropDown_v2',
                Framing: 'PurchasePopup_FramingDropDown',
                MediaV1: 'PurchasePopup_MediaDropDown',     // DEPRECATED - use `Name.Block.PurchasePopup.DropDown.MediaV2`
                MediaV2: 'PurchasePopup_MediaDropDown_v2',
                PriceV1: 'PurchasePopup_PriceDropDown',     // DEPRECATED - use `Name.Block.PurchasePopup.DropDown.PriceV2`
                PriceV2: 'PurchasePopup_PriceDropDown_v2'
            },
            ErrorMessage: 'PurchasePopup_ErrorMessage',
            SuccessMessage: 'PurchasePopup_SuccessMessage',
            SubmitButtonV1: 'PurchasePopup_SubmitButton',   // DEPRECATED - use `Name.Block.PurchasePopup.SubmitButtonV2`
            SubmitButtonV2: 'PurchasePopup_SubmitButton_v2'
        },
        SearchResult: {
            Cell: {
                Image: {
                    Artist: 'SearchResult_Image_Artist',
                    Blog: 'SearchResult_Image_Blog',
                    Inventory: 'SearchResult_Image_Inventory',
                    Show: 'SearchResult_Image_Show'
                },
                Text: {
                    Artist: 'SearchResult_Meta_Artist',
                    Blog: 'SearchResult_Meta_Blog',
                    Inventory: 'SearchResult_Meta_Inventory',
                    Show: 'SearchResult_Meta_Show'
                }
            },
            List: 'SearchResult_List',
            Meta: 'SearchResult_Meta'
        },
        Show: {
            Artist: {
                List: 'Show_ArtistsList',                     // DEPRECATED - use `Name.Block.Show.Artist.ListV2`
                ListV2: 'Show_ArtistsList_v2'
            },
            Blog: {
                List: 'Show_Blogs'
            },
            Cell: {
                DetailButtonV1: 'Show_Cell_Detail_Button',    // DEPRECATED - use `Name.Block.Show.Cell.DetailButtonV3`
                DetailButtonV2: 'Show_Cell_Detail_Button_v2', // DEPRECATED - use `Name.Block.Show.Cell.DetailButtonV3`
                DetailButtonV3: 'Show_Cell_Detail_Button_v3',
                Image: 'Show_Cell_Image',
                Text: 'Show_Cell_Meta'
            },
            Description: 'Show_Meta_Tokenized-Description',
            ImageParallax: 'Show_ImageParallax',
            ImageV1: 'Show_Image',                          // DEPRECATED - use `Name.Block.Show.ImageV2`
            ImageV2: 'Show_Image_v2',
            Inventory: {
                ListV1: 'Show_Inventory',                   // DEPRECATED - use `Name.Block.Show.Inventory.ListV4`
                ListV2: 'Show_Inventory_v2',                // DEPRECATED - use `Name.Block.Show.Inventory.ListV4`
                ListV3: 'Show_Inventory_v3',                // DEPRECATED - use `Name.Block.Show.Inventory.ListV4`
                ListV4: 'Show_Inventory_v4'
            },
            List: {
                Grid: 'Shows',
                Parallax: 'ShowsParallax',
                Slideshow: 'ShowsSlideshow',
                SlideshowFullBackground: 'ShowsSlideshow-FullBackground'
            },
            Media: {
                List: 'Show_Media'
            },
            TabsV1: 'Show_Tabs',                            // DEPRECATED - use `Name.Block.Show.TabsV3`
            TabsV2: 'Show_Tabs_v2',                         // DEPRECATED - use `Name.Block.Show.TabsV3`
            TabsV3: 'Show_Tabs_v3',
            TitleV1: 'Show_Meta_Tokenized-Title',
            TitleV2: 'Show_Meta_Tokenized-Title_v2'         // DEPRECATED - use `Name.Block.Show.TitleV1`
        },
        SignUpButtonV1: 'SignUpButton',                     // DEPRECATED - use `Name.Block.SignUpButtonV3`
        SignUpButtonV2: 'SignUpButton_v2',                  // DEPRECATED - use `Name.Block.SignUpButtonV3`
        SignUpButtonV3: 'SignUpButton_v3',
        Slider: {
            Carousel: 'Slider',
            Cell: {
                Image: 'Slide_Cell_Image'
            }
        },
        SocialV1: 'Social',                                 // DEPRECATED - use `Name.Block.SocialV2`
        SocialV2: 'Social_v2',
        SubscribeForm: {
            Container: 'SubscribeForm',
            ErrorMessage: 'SubscribeForm_ErrorMessage',
            Input: {
                Address: {
                    City: 'SubscribeForm_AddressCity',
                    Country: 'SubscribeForm_AddressCountry',
                    Line1: 'SubscribeForm_AddressLine1',
                    Line2: 'SubscribeForm_AddressLine2',
                    State: 'SubscribeForm_AddressState',
                    Zip: 'SubscribeForm_AddressZip'
                },
                Email: 'SubscribeForm_Email',
                Name: 'SubscribeForm_Name',
                Phone: 'SubscribeForm_Phone'
            },
            SuccessMessage: 'SubscribeForm_SuccessMessage',
            SubmitButtonV1: 'SubscribeForm_SubmitButton',   // DEPRECATED - use `Name.Block.SubscribeForm.SubmitButtonV2`
            SubmitButtonV2: 'SubscribeForm_SubmitButton_v2',

            baseFromContext: (context) => context == PageType.Form.FooterSubscribe || context == PageType.Footer ? Name.Block.Footer.SubscribeForm : Name.Block.SubscribeForm
        },
        Tabs: 'Tabs',
        TabsV3: 'Tabs_v3',
        Text: 'text',
        Video: 'Video',
        VideoHero: 'VideoHero'
    },
    SocialPlatform: {
        ArtCloud: 'artcloud',
        Artnet: 'artnet',
        Artsy: 'artsy',
        Bluesky: 'bluesky',
        Email: 'email',
        Facebook: 'facebook',
        FirstDibs: 'dibs',
        Houzz: 'houzz',
        Instagram: 'instagram',
        LinkedIn: 'linkedin',
        Pinterest: 'pinterest',
        TikTok: 'tiktok',
        Twitter: 'twitter',
        Vimeo: 'vimeo',
        WhatsApp: 'whatsapp',
        YouTube: 'youtube',

        configProps: (platform, config, v2 = false) => {
            const _config = config || {};
            const suffix = v2 ? '-2' : '';
            let iconClassName, url;
            switch (platform) {
                case Name.SocialPlatform.ArtCloud:
                    iconClassName = `i i-ac-social${suffix}`;
                    url = _config.artCloudUrl;
                    break;
                case Name.SocialPlatform.Artnet:
                    iconClassName = `i i-artnet${suffix}`;
                    url = _config.artnetUrl;
                    break;
                case Name.SocialPlatform.Artsy:
                    iconClassName = `i i-artsy${suffix}`;
                    url = _config.artsyUrl;
                    break;
                case Name.SocialPlatform.Bluesky:
                    iconClassName = `i i-bsky${suffix}`;
                    url = _config.blueskyUrl;
                    break;
                case Name.SocialPlatform.Email:
                    iconClassName = `i i-mail${suffix}`;
                    break;
                case Name.SocialPlatform.Facebook:
                    iconClassName = `i i-fcbk${suffix}`;
                    url = _config.facebookUrl;
                    break;
                case Name.SocialPlatform.FirstDibs:
                    iconClassName = `i i-st${suffix}`;
                    url = _config.firstDibsUrl;
                    break;
                case Name.SocialPlatform.Houzz:
                    iconClassName = `i i-houzz${suffix}`;
                    url = _config.houzzUrl;
                    break;
                case Name.SocialPlatform.Instagram:
                    iconClassName = `i i-inst${suffix}`;
                    url = _config.instagramUrl;
                    break;
                case Name.SocialPlatform.LinkedIn:
                    iconClassName = `i i-linkedin${suffix}`;
                    url = _config.linkedInUrl;
                    break;
                case Name.SocialPlatform.Pinterest:
                    iconClassName = `i i-pint${suffix}`;
                    url = _config.pinterestUrl;
                    break;
                case Name.SocialPlatform.TikTok:
                    iconClassName = `i i-tiktok${suffix}`;
                    url = _config.tikTokUrl;
                    break;
                case Name.SocialPlatform.Twitter:
                    iconClassName = `i i-twit${suffix}`;
                    url = _config.twitterUrl;
                    break;
                case Name.SocialPlatform.Vimeo:
                    iconClassName = `i i-vimeo${suffix}`;
                    url = _config.vimeoUrl;
                    break;
                case Name.SocialPlatform.WhatsApp:
                    iconClassName = `i i-chat${suffix}`;
                    url = _config.whatsAppUrl;
                    break;
                case Name.SocialPlatform.YouTube:
                    iconClassName = `i i-youtube${suffix}`;
                    url = _config.youTubeUrl;
                    break;
            }
            return { iconClassName, url };
        }
    },
    Template: {
        Shared: {
            ContactFormLeftMetaRight: 'ContactFormLeftMetaRight',
            Image3ColumnsHeaderTextAbove: 'Image3ColumnsHeaderTextAbove',
            ImageHeaderTextLeft: 'ImageHeaderTextLeft',
            ImageHeaderTextRight: 'ImageHeaderTextRight',
            ImageRoundHeaderSubheaderTextBelow: 'ImageRoundHeaderSubheaderTextBelow',
            ImageRoundSubheaderTextRight2ColumnsHeaderTextAbove: 'ImageRoundSubheaderTextRight2ColumnsHeaderTextAbove',
            ImageRoundSubheaderTextRight2RowsHeaderAbove: 'ImageRoundSubheaderTextRight2RowsHeaderAbove',
            ImageText2Columns: 'ImageText2Columns',
            ImageText3Columns: 'ImageText3Columns',
            ImageTextLeft: 'ImageTextLeft',
            ImageTextRight: 'ImageTextRight',
            ImageTextRight2Columns: 'ImageTextRight2Columns',
            MapHeaderTextRight: 'MapHeaderTextRight',
            VideoTextBelow: 'VideoTextBelow',
            VideoTextLeft: 'VideoTextLeft',
            VideoTextRight: 'VideoTextRight'
        },

        [PageType.Footer]: {
            desktop: {
                FooterTemplate: 'FooterTemplate'
            }
        },
        [PageType.Header]: {
            desktop: {
                HeaderTemplate1: 'HeaderTemplate1'
            }
        },
        [PageType.InventoryDetailModal]: {
            InventoryDetailModalTemplate: 'InventoryDetailModalTemplate',
            InventoryDetailModalTemplate1: 'InventoryDetailModalTemplate1'
        }
    }
}
Name.Template[PageType.Content.Blog] = {
    ImageRoundHeaderSubheaderTextBelow: Name.Template.Shared.ImageRoundHeaderSubheaderTextBelow,
    Image3ColumnsHeaderTextAbove: Name.Template.Shared.Image3ColumnsHeaderTextAbove,
    ImageTextRight: Name.Template.Shared.ImageTextRight,
    ImageTextLeft: Name.Template.Shared.ImageTextLeft,
    ImageTextRight2Columns: Name.Template.Shared.ImageTextRight2Columns,
    ImageText3Columns: Name.Template.Shared.ImageText3Columns,
    ImageText2Columns: Name.Template.Shared.ImageText2Columns,
    ImageHeaderTextRight: Name.Template.Shared.ImageHeaderTextRight,
    ImageHeaderTextLeft: Name.Template.Shared.ImageHeaderTextLeft,
    MapHeaderTextRight: Name.Template.Shared.MapHeaderTextRight,
    VideoTextBelow: Name.Template.Shared.VideoTextBelow,
    VideoTextRight: Name.Template.Shared.VideoTextRight,
    VideoTextLeft: Name.Template.Shared.VideoTextLeft,
    ImageRoundSubheaderTextRight2RowsHeaderAbove: Name.Template.Shared.ImageRoundSubheaderTextRight2RowsHeaderAbove,
    ImageRoundSubheaderTextRight2ColumnsHeaderTextAbove: Name.Template.Shared.ImageRoundSubheaderTextRight2ColumnsHeaderTextAbove
};
Name.Template[PageType.Content.Media] = {
    VideoTextBelow: Name.Template.Shared.VideoTextBelow,
    VideoTextRight: Name.Template.Shared.VideoTextRight,
    VideoTextLeft: Name.Template.Shared.VideoTextLeft,
    ImageText3Columns: Name.Template.Shared.ImageText3Columns
};
Name.Template[PageType.Content.Tab] = {
    ContactFormLeftMetaRight: Name.Template.Shared.ContactFormLeftMetaRight,
    ImageRoundHeaderSubheaderTextBelow: Name.Template.Shared.ImageRoundHeaderSubheaderTextBelow,
    Image3ColumnsHeaderTextAbove: Name.Template.Shared.Image3ColumnsHeaderTextAbove,
    ImageTextRight: Name.Template.Shared.ImageTextRight,
    ImageTextLeft: Name.Template.Shared.ImageTextLeft,
    ImageTextRight2Columns: Name.Template.Shared.ImageTextRight2Columns,
    ImageText3Columns: Name.Template.Shared.ImageText3Columns,
    ImageText2Columns: Name.Template.Shared.ImageText2Columns,
    ImageHeaderTextRight: Name.Template.Shared.ImageHeaderTextRight,
    ImageHeaderTextLeft: Name.Template.Shared.ImageHeaderTextLeft,
    MapHeaderTextRight: Name.Template.Shared.MapHeaderTextRight,
    VideoTextBelow: Name.Template.Shared.VideoTextBelow,
    VideoTextRight: Name.Template.Shared.VideoTextRight,
    VideoTextLeft: Name.Template.Shared.VideoTextLeft,
    ImageRoundSubheaderTextRight2RowsHeaderAbove: Name.Template.Shared.ImageRoundSubheaderTextRight2RowsHeaderAbove,
    ImageRoundSubheaderTextRight2ColumnsHeaderTextAbove: Name.Template.Shared.ImageRoundSubheaderTextRight2ColumnsHeaderTextAbove
};
Name.Template[PageType.Custom] = {
    ContactFormLeftMetaRight: Name.Template.Shared.ContactFormLeftMetaRight,
    ImageRoundHeaderSubheaderTextBelow: Name.Template.Shared.ImageRoundHeaderSubheaderTextBelow,
    Image3ColumnsHeaderTextAbove: Name.Template.Shared.Image3ColumnsHeaderTextAbove,
    ImageTextRight: Name.Template.Shared.ImageTextRight,
    ImageTextLeft: Name.Template.Shared.ImageTextLeft,
    ImageTextRight2Columns: Name.Template.Shared.ImageTextRight2Columns,
    ImageText3Columns: Name.Template.Shared.ImageText3Columns,
    ImageText2Columns: Name.Template.Shared.ImageText2Columns,
    ImageHeaderTextRight: Name.Template.Shared.ImageHeaderTextRight,
    ImageHeaderTextLeft: Name.Template.Shared.ImageHeaderTextLeft,
    MapHeaderTextRight: Name.Template.Shared.MapHeaderTextRight,
    VideoTextBelow: Name.Template.Shared.VideoTextBelow,
    VideoTextRight: Name.Template.Shared.VideoTextRight,
    VideoTextLeft: Name.Template.Shared.VideoTextLeft,
    ImageRoundSubheaderTextRight2RowsHeaderAbove: Name.Template.Shared.ImageRoundSubheaderTextRight2RowsHeaderAbove,
    ImageRoundSubheaderTextRight2ColumnsHeaderTextAbove: Name.Template.Shared.ImageRoundSubheaderTextRight2ColumnsHeaderTextAbove
};

export default Name;